import { render, staticRenderFns } from "./create_shortcut.vue?vue&type=template&id=ae51b748&scoped=true"
import script from "./create_shortcut.vue?vue&type=script&lang=js"
export * from "./create_shortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae51b748",
  null
  
)

export default component.exports